import { SendCMD } from "@/utils/HTTPRequest";

let latestRequest = 0;

export const getGuestRegisterEnabled = (getPersist) => {
  const known = getPersist("guest_register_enabled");
  if (typeof known === "boolean") return known;
  const settings = getPersist("bgSettings");
  if (!settings || settings.status !== true) return undefined;
  const config = settings.settings && settings.settings.client_config;
  const value = config ? config.guestRegisterEnabled : undefined;
  return value === undefined ? true : typeof value === "boolean" ? value : undefined;
};

export const markGuestRegistrationDisabled = (setPersist) => {
  // Discard config requests started before this authoritative server rejection.
  latestRequest += 1;
  setPersist("guest_register_enabled", false);
};

const getStoredObject = (key) => {
  const value = localStorage.getItem(key);
  if (!value) {
    return {};
  }
  try {
    const parsed = JSON.parse(value);
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return parsed;
    }
  } catch (e) {
    console.error(e);
  }
  return {};
};

export const LoadBgSettings = async (location, getPersist, setPersist) => {
  const requestId = ++latestRequest;
  const query = new URLSearchParams(location && location.search ? location.search : window.location.search);
  const pathname = location && location.pathname ? location.pathname : window.location.pathname;
  let channel = query.get("c");
  if (!channel && pathname.startsWith("/c/")) {
    channel = pathname.substring(3);
  }
  if (getPersist("channel")) {
    channel = getPersist("channel");
  } else if (channel) {
    setPersist("channel", channel);
  }

  const res = await SendCMD("bgSettings", {
    channel,
    guest_id: window.guestId ? window.guestId() : "",
    first_visit_url: localStorage.getItem("first_visit_url"),
    first_visit_time: localStorage.getItem("first_visit_time"),
  });
  console.log("bgSettings res", res);

  if (!res || res.status !== true || requestId !== latestRequest) return res;
  const clientConfig = res.settings && res.settings.client_config;
  const guestRegisterEnabled = clientConfig ? clientConfig.guestRegisterEnabled : undefined;
  if (guestRegisterEnabled === undefined || typeof guestRegisterEnabled === "boolean") {
    setPersist("guest_register_enabled", guestRegisterEnabled === undefined ? true : guestRegisterEnabled);
  }

  const channelInfo = res && res.settings && res.settings.channel_info;
  if (channelInfo && channelInfo.fb_id) {
    console.log("fb_pixel_id", channelInfo.fb_id);
    setPersist("fb_pixel_id", channelInfo.fb_id);
  }
  if (channelInfo && channelInfo.boomplay_id) {
    console.log("boomplay_id", channelInfo.boomplay_id);
    localStorage.setItem("attribution", "boomplay");
    localStorage.setItem("attribution_id", channelInfo.boomplay_id);
    const oldAdSource = getStoredObject("ad_source");
    oldAdSource.click_id = query.get("click_id") ? query.get("click_id") : oldAdSource.click_id;
    oldAdSource.click_time = query.get("click_time") ? query.get("click_time") : oldAdSource.click_time;
    oldAdSource.account_id = query.get("account_id") ? query.get("account_id") : oldAdSource.account_id;
    oldAdSource.data_source_id = query.get("data_source_id") ? query.get("data_source_id") : oldAdSource.data_source_id;
    oldAdSource.ip = query.get("ip") ? query.get("ip") : oldAdSource.ip;
    oldAdSource.user_agent = query.get("user_agent") ? query.get("user_agent") : oldAdSource.user_agent;
    oldAdSource.ad_id = query.get("ad_id") ? query.get("ad_id") : oldAdSource.ad_id;
    oldAdSource.callback_url = query.get("callback_url") ? query.get("callback_url") : oldAdSource.callback_url;
    localStorage.setItem("ad_source", JSON.stringify(oldAdSource));
    setPersist("boomplay_id", channelInfo.boomplay_id);
  }
  if (channelInfo && channelInfo.mgsky_id) {
    localStorage.setItem("attribution", "mgsky");
    localStorage.setItem("attribution_id", channelInfo.mgsky_id);
    const oldAdSource = getStoredObject("ad_source");
    oldAdSource.pixel_click_id = query.get("pixel_click_id") ? query.get("pixel_click_id") : oldAdSource.pixel_click_id;
    oldAdSource.pixel_id = query.get("pixel_id") ? query.get("pixel_id") : oldAdSource.pixel_id;
    oldAdSource.clickid = query.get("clickid") ? query.get("clickid") : oldAdSource.clickid;
    oldAdSource.gaid = query.get("gaid") ? query.get("gaid") : oldAdSource.gaid;
    oldAdSource.utm_source = query.get("utm_source") ? query.get("utm_source") : oldAdSource.utm_source;
    localStorage.setItem("ad_source", JSON.stringify(oldAdSource));
    setPersist("mgsky_id", channelInfo.mgsky_id);
  }
  if (channelInfo && channelInfo.okspin_id) {
    console.log("okspin_id", channelInfo.okspin_id);
    localStorage.setItem("attribution", "okspin");
    localStorage.setItem("attribution_id", channelInfo.okspin_id);
    setPersist("okspin_id", channelInfo.okspin_id);
  }
  if (res) {
    setPersist("bgSettings", res);
    if (res.abtest_tag) {
      setPersist("abtest_tag", res.abtest_tag);
    }
    if (res.client_show_time) {
      setPersist("client_show_time", res.client_show_time);
    }
    setPersist("recall_act_open", false);
    if (res.recall_act_open && res.recall_act_now && res.recall_act_end_time && res.recall_act_now < res.recall_act_end_time) {
      setPersist("recall_act_open", res.recall_act_open);
    }
  }
  return res;
};
